module.exports = __webpack_public_path__ + "static/media/moon.38960eac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moon.svg
// module id = 878
// module chunks = 7